export default __webpack_public_path__ + "static/media/V2-CARROUSEL_5.0b5e752d.png";